import React, { useRef, useState } from "react";
import { Input, Form, Button, Icon } from "antd";
import { EditableContext } from "./EditableFormRow";

const EditableCell = props => {
  const { editable, children } = props;

  const [editing, setEditing] = useState(false);

  const formRef = useRef();

  const toggleEdit = () => {
    setEditing(editing => !editing);
  };

  const save = e => {
    const { record, handleSave } = props;
    // @ts-ignore
    formRef.current.validateFields((error, values) => {
      if (error && error[e.currentTarget.id]) {
        return;
      }
      toggleEdit();
      handleSave({ ...record, ...values });
    });
  };

  const renderCell = form => {
    formRef.current = form;
    const { children, dataIndex, record, title } = props;

    return editing ? (
      <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(dataIndex, {
          rules: [
            {
              required: true,
              message: `${title} is required.`
            }
          ],
          initialValue: record[dataIndex]
        })(
          <Input
            autoFocus
            onPressEnter={save}
            onBlur={save}
          />
        )}
      </Form.Item>
    ) : (
      <div role="button" tabIndex={0} onClick={toggleEdit}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {children}
          <Button style={{marginLeft: 20}}>
            <Icon type="edit" />
          </Button>
        </div>
      </div>
    );
  };

  return (
    // @ts-ignore
    <td {...props}>
      {editable ? (
        <EditableContext.Consumer>{renderCell}</EditableContext.Consumer>
      ) : (
        children
      )}
    </td>
  );
};

export default EditableCell;



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAgencyPage/EditableTable/EditableCell.tsx